import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Menu, MenuItem, Collapse } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { withRouter, Link } from 'react-router-dom';
import { withLocal } from '../LocaleProvider/LocaleProvider';
import { useAlert } from '../AlertProvider/AlertProvider';
import brand from '../../../assets/ascension_logo.png';
import routes from '../../../constants/routes';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 8px',
    height: '65px',
    backgroundColor: theme.palette.primary.dark
  },
  alert: {
    position: 'absolute'
  },
  alertMessage: {
    padding: '8px',
    color: '#fff'
  }
}));

export const Banner = ({ history, locale, setLocale }) => {
  const classes = useStyles();

  const { alert, setAlert } = useAlert();

  const [mainMenuAnchor, setMainMenuAnchor] = useState(null);
  const [localeMenuAnchor, setLocaleMenuAnchor] = useState(null);

  useEffect(() => {
    if (!!alert.text) {
      setTimeout(() => {
        setAlert({});
      }, 4000);
    }
  }, [alert, setAlert]);

  const handleSelectLangClick = () => {
    setLocaleMenuAnchor(mainMenuAnchor);
    setMainMenuAnchor(null);
  };

  const handleLocaleClick = locale => {
    setLocale(locale);
    setLocaleMenuAnchor(null);
  };

  const handleSignOut = () => {
    setMainMenuAnchor(null);
    history.push(routes.SIGN_OUT);
  };

  return (
    <>
      <div className={classes.root}>
        <Link to={routes.HOME_PAGE} style={{ float: 'left', width: 'auto' }}>
          <img style={{ height: '30px' }} src={brand} alt="Ascension" />
        </Link>
        <IconButton
          aria-controls="main-menu"
          aria-haspopup="true"
          data-testid="menu-btn"
          onClick={e => setMainMenuAnchor(e.currentTarget)}
          color="secondary"
        >
          <MenuIcon alt="menu" />
        </IconButton>
        <Menu
          id="main-menu"
          anchorEl={mainMenuAnchor}
          keepMounted
          open={Boolean(mainMenuAnchor)}
          onClose={() => setMainMenuAnchor(null)}
        >
          <MenuItem onClick={() => handleSelectLangClick()}>
            {locale.banner.select_language}
          </MenuItem>
          {history.location.pathname !== '/' && (
            <MenuItem onClick={() => handleSignOut()}>
              {locale.banner.sign_out}
            </MenuItem>
          )}
        </Menu>
        <Menu
          id="locale-menu"
          anchorEl={localeMenuAnchor}
          keepMounted
          open={Boolean(localeMenuAnchor)}
          onClose={() => setLocaleMenuAnchor(null)}
        >
          <MenuItem onClick={() => handleLocaleClick('en')}>English</MenuItem>
          <MenuItem onClick={() => handleLocaleClick('es')}>Spanish</MenuItem>
        </Menu>
      </div>
      <Collapse
        in={!!alert.text}
        timeout="auto"
        classes={{ wrapperInner: classes.alert }}
      >
        <div
          className={classes.alertMessage}
          style={{ backgroundColor: alert.color }}
        >
          {alert.text}
        </div>
      </Collapse>
    </>
  );
};

export default withRouter(withLocal(Banner));
